import { gql } from 'apollo-angular'

import { AUTHOR_EXTENDED_FIELDS } from '../../fragments/author.fragments'

export const GET_ARTICLES_BY_EDITION_ID = gql`
  ${AUTHOR_EXTENDED_FIELDS}
  query getArticlesByEditionId(
    $editionId: Article_edition_operator!
    $limit: Int
    $fetchDetails: Boolean!
  ) {
    Articles(
      where: {
        AND: [{ edition: $editionId }, { published_at: { not_equals: null } }]
      }
      limit: $limit
      sort: "edition_order"
    ) {
      docs {
        id
        title
        slug
        published_at
        content_preview
        article_type
        users {
          authors @include(if: $fetchDetails) {
            ...AuthorExtendedFields
          }
        }
      }
      totalDocs
      totalPages
      page
    }
  }
`
